(function ($) {
    $(document).ready(function () {
        $('.menu').smartmenus();



        $('header nav .dropdown > a').click(function(e) {
            if ($(this).attr('href') == '#') {
                e.preventDefault();
            }
            var parent = $(this).parent();

            var open = !parent.hasClass('open');
            $('header nav > ul > li .open').removeClass('open');

            if (open) {
                $(this).parent().children('ul').addClass('open');
                $(this).parent().addClass('open');
            }
        });

        $('header nav > ul > li').mouseleave(function() {
            if (breakpoint('lg')) {
                $(this).find('.open').removeClass('open');
            }
        });

        $('#menu-toggle').click(function() {
            if (!breakpoint('lg')) {
                $('.main-menu').toggle();
            }
        });
        
        if ($('header ul li ul li').hasClass('active')){
            $('li.active').parents('li').addClass('active');

        }
        
        $('#search-form .search-enable').click(function() {
            setTimeout(function() {
                $('#search-form .search-enable').css('z-index', 0);
            }, 500);
            $(this).addClass('open');
            $('#search-form form').addClass('open');
        });

        $('#search-form input').blur(function() {
            if (!breakpoint('xs') && $(this).val().length === 0) {
                $('#search-form .search-enable').css('z-index', 10);
                $('#search-form .search-enable').removeClass('open');
                $('#search-form form').removeClass('open');
            }
        });
    });
    $(document).ready(function () {
        $('.publication-slider .slider-container').slick({
            slidesToShow:4,
            prevArrow: $ ('.prev-slide'),
            nextArrow: $ ('.next-slide'),
            responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 4,
                  }
                },
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                     breakpoint: 500,
                      settings: {
                        slidesToShow: 1,
                      }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
              ]
        });

    });
 $(document).ready(function () {
        $('.event-slider .slider-container').slick({
            slidesToShow:4,
            prevArrow: $ ('.prev-slide'),
            nextArrow: $ ('.next-slide'),
            responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 4,
                  }
                },
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                     breakpoint: 500,
                      settings: {
                        slidesToShow: 1,
                      }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
              ]
        });
    });
    $(window).load(function () {
        setEqualHeight('.single-publikacja .description');

        if (window.matchMedia('(min-width: 768px)').matches) {
            setEqualHeight('.logotyp .files p');
        }
        else {
            $('.logotyp .files p').height('auto');
        }
        if (window.matchMedia('(min-width: 540px)').matches) {
            setEqualHeight('.single-news .info .title');
            setEqualHeight('.single-news');
            setEqualHeight('.single-event .thumb img');
            setEqualHeight('.single-event .description');
            setEqualHeight('.single-event .title');
            setEqualHeight('.single-event .city');
            setEqualHeight('.single-project img');
        }
        else {
            $('.single-news .info .title').height('auto');
            $('.single-news').height('auto');
            $('.single-event .thumb img').height('auto');
            $('.single-event .description').height('auto');
            $('.single-event .title').height('auto');
            $('.single-event .city').height('auto');
            $('.single-event .city').height('auto');
        }
        if (window.matchMedia('(min-width: 500px)').matches) {
            setEqualHeight('.single-inicjatywa .title');
        }
        else {
            $('.single-project img').height('auto');
        }
    });
    $(window).resize(function () {

        setEqualHeight('.single-publikacja .description');
        if (window.matchMedia('(min-width: 768px)').matches) {
            setEqualHeight('.logotyp .files p');
        }
        else {
            $('.logotyp .files p').height('auto');
        }
        if (window.matchMedia('(min-width: 540px)').matches) {
            setEqualHeight('.single-news .info .title');
            setEqualHeight('.single-news');
            setEqualHeight('.single-event .thumb img');
            setEqualHeight('.single-event .description');
            setEqualHeight('.single-event .title');
            setEqualHeight('.single-event .city');
            setEqualHeight('.single-project img');
        }
        else {
            $('.single-news .info .title').height('auto');
            $('.single-news').height('auto');
            $('.single-event .thumb img').height('auto');
            $('.single-event .description').height('auto');
            $('.single-event .title').height('auto');
            $('.single-event .city').height('auto');
            $('.single-project img').height('auto');
        }
    });
       function setEqualHeight(elem) {
                $(elem).height('auto');
                var maxH = 0;
                $(elem).each(function() {
                    if ($(this).height() > maxH) {
                        maxH = $(this).height();
                    }
                });
                $(elem).height(maxH);
            }
    

})(jQuery);

function breakpoint() {
    function detect() {
        switch (parseInt(getComputedStyle(document.querySelector('.container')).width)) {
            case 750:
                return 'sm';
            case 970:
                return 'md';
            case 1170:
                return 'lg';
            default:
                return 'xs';
        }
    }

    var current = detect();

    if (arguments.length === 0) {
        return current;
    }

    for (var i = 0; i < arguments.length; i++) {
        if (arguments[i] === current) {
            return true;
        }
    }

    return false;
}
